import '../classes/styles/style.css';
import Screen from '../components/screen';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import * as WS from '../webServices/cyMyManager'
import { useState, useEffect, useContext } from 'react';
import { EventInput } from '@fullcalendar/core';
import * as UT from '../classes/utility'
// import { GlobalContextData, GetGlobalContext } from '../classes/context';
import Modal from '../components/modal';
import { GetGlobalContext, GlobalContextData } from '../classes/context';

export default function Prenotazioni() {
    const globalContext = useContext<GlobalContextData>(GetGlobalContext);
    const [prenotaz, setPrenotaz] = useState<WS.Plus.IF.Prenotazione[] | undefined>(undefined);
    const [eventiCal, setEventiCal] = useState<EventInput[]>([]);

    const [prenoDel, setPrenoDel] = useState<WS.Plus.IF.Prenotazione | undefined>(undefined);

    const [calendarView, setCalendarView] = useState(window.innerWidth < 768 ? 'dayGridDay' : 'dayGridMonth');
    const [headerToolbar, setHeaderToolbar] = useState({
        left: window.innerWidth < 768 ? 'dayGridDay' : 'dayGridMonth,dayGridWeek,dayGridDay'
    });


        const handleResize = () => {
            setCalendarView(window.innerWidth < 768 ? 'dayGridDay' : 'dayGridMonth');
        };


    const getPrenotaz = async () => {
        let listSedi = await WS.Plus.getListaSediEsercenti(WS.UT.TOKEN, "", globalContext.vars.esercente?.Id ?? 0, 0, 0, 1, 0);
        const data = await WS.Plus.getListPrenotazioni(WS.UT.TOKEN, '', 0, 0);

        const sediIds = listSedi.list.map(sede => sede.Id);

        const filteredPrenotazioni = data.list.filter(p =>
            sediIds.includes(p.IdSedeEserc)
        );



        let newEventi: EventInput[] = filteredPrenotazioni.map(p => ({
            title: `${p.DesCli} - ${p.DesArt}`,
            start: `${p.DataPren}T${UT.timeToString(p.OraIni)}:00`,
            end: `${p.DataPren}T${UT.timeToString(p.OraFin)}:00`,
            allDay: false,
            extendedProps: {
                idPreno: p.Id
            }
        }));

        // let newEventi: EventInput[] = [];

        // data.list.forEach(p => {
        //     newEventi.push({
        //         title: p.DesCli + ' - ' + p.DesArt,
        //         start: p.DataPren + 'T' + UT.timeToString(p.OraIni) + ':00',
        //         end: p.DataPren + 'T' + UT.timeToString(p.OraFin) + ':00', // a property! ** see important note below about 'end' **
        //         allDay: false,
        //         extendedProps: {
        //             'idPreno': p.Id
        //         }
        //     })
        // });

        setPrenotaz(data.list);
        setEventiCal(newEventi);
    };

    useEffect(() => {
        getPrenotaz();

        const handleResize = () => {
            const isMobile = window.innerWidth < 768;
            setCalendarView(isMobile ? 'dayGridDay' : 'dayGridMonth');
            setHeaderToolbar({
                left: isMobile ? 'dayGridMonth,dayGridDay' : 'dayGridMonth,dayGridWeek,dayGridDay'
            });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <Screen>
            <div className='container'>
                <div className='row card mb-3'>
                    <h2>Prenotazioni</h2>
                </div>
                <div className='row card '>
                    <FullCalendar
                        plugins={[dayGridPlugin, interactionPlugin]}
                        initialView={calendarView}
                        headerToolbar={headerToolbar}
                        locale={'it'}
                        titleFormat={{
                            'year': 'numeric',
                            'month': 'short'
                        }}
                        buttonText={{
                            'today': 'Oggi',
                            'month': 'Mese',
                            'day': 'Giorno',
                            'week': 'Settimana'
                        }}

                        dayHeaderFormat={ window.innerWidth < 768 ?{
                            weekday: 'short', // Nome breve del giorno
                            day: 'numeric',     // Numero del giorno
                            month: 'long'
                        }: undefined}
                        editable={false}
                        selectable={true}
                        dateClick={(info) => {
                            // console.log(info.date)
                        }}
                        events={eventiCal}
                        eventClick={(info) => {
                            const idPrenoDel = info.event.extendedProps.idPreno as number;

                            setPrenoDel(prenotaz?.find(x => x.Id === idPrenoDel));
                        }}
                    />
                </div>
            </div>
            <Modal
                isShow={prenoDel !== undefined}
                body={
                    <div>
                        <p>
                            <h5>
                                Conferma eliminazione prenotazione?
                            </h5>
                        </p>
                        <p>
                            {`Orario: ${UT.timeToString(prenoDel?.OraIni ?? 0)} - ${UT.timeToString(prenoDel?.OraFin ?? 0)}`}
                            <br />
                            {`Cliente: ${prenoDel?.DesCli}`}
                            <br />
                            {`Servizio: ${prenoDel?.DesArt}`}
                        </p>
                    </div>
                }
                onClose={() => setPrenoDel(undefined)}
                onDel={async () => {
                    if (!prenoDel) return;
                    await WS.Plus.deletePrenotazione(WS.UT.TOKEN, prenoDel.Id);
                    await getPrenotaz();
                    setPrenoDel(undefined);
                }}
            />
        </Screen>
    );
}

